import { Component } from 'solid-js';

interface HeaderProps {
  onToggleSettings: () => void;
  onToggleSessions?: () => void;
  settingsOpen: boolean;
}

export const Header: Component<HeaderProps> = (props) => {
  return (
    <header class="header-row" role="banner">
      <h1 id="app-title">
        <span class="app-icon" role="img" aria-label="Brain icon">🧠</span>
        ActuallyGood.Ai
      </h1>
      <button 
        type="button"
        class="settings-btn"
        onClick={() => props.onToggleSessions?.()}
        aria-label="Open conversations"
        title="Open conversations"
      >
        <span role="img" aria-hidden="true">📂</span>
        <span class="btn-text">Sessions</span>
      </button>

      <button 
        type="button"
        class="settings-btn"
        onClick={props.onToggleSettings}
        aria-label={props.settingsOpen ? 'Close settings panel' : 'Open settings panel'}
        data-expanded={props.settingsOpen ? 'true' : 'false'}
      >
        <span role="img" aria-hidden="true">⚙️</span>
        <span class="btn-text">Settings</span>
      </button>
    </header>
  );
};